import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { getBayphonesTableDefinitions, bayphoneQueries } from './BayphoneTableDefinitions'

class BayphoneTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "BayphoneTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, bayphoneQueries)

        const fieldDefinitions = getBayphonesTableDefinitions(false);
        tableCreator.addDescriptions(fieldDefinitions);

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(BayphoneTableCreator)

export default BayphoneTableCreator
